import {
  Avatar,
  Box,
  Divider,
  Grid2,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import React from "react";

import Logout from "@mui/icons-material/Logout";

import { useNavigate } from "react-router";

export function UserMenu() {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );
  const navigate = useNavigate();

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    handleCloseUserMenu();
    localStorage.removeItem("AuthToken");
    navigate("/");
  };

  return (
    <Box sx={{ flexGrow: 0, marginLeft: 4 }}>
      <IconButton
        onClick={handleOpenUserMenu}
        sx={{ p: 0, color: "white" }}
        size="large"
      >
        <Avatar {...stringAvatar("Wagneia Cristina")} />
      </IconButton>
      <Menu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem>
          <Grid2 container spacing={2}>
            <Grid2>
              <Avatar {...stringAvatar("Wagneia Cristina")} />
            </Grid2>
            <Grid2>
              <Grid2 container flexDirection="column">
                <Grid2>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", margin: 0 }}
                  >
                    Wagneia Cristina
                  </Typography>
                </Grid2>
                <Grid2>
                  <Typography variant="subtitle2">wagneia@gmail.com</Typography>
                </Grid2>
              </Grid2>
            </Grid2>
          </Grid2>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
}

function stringAvatar(name: string) {
  return {
    children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
  };
}
